import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  setSearchTerm({ commit }, text) {
    commit(types.SET_SEARCH_TERM, text)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setSortDir({ commit }, sortDir) {
    commit(types.SET_SORT_DIR, sortDir)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setFilterBy({ commit }, filterBy) {
    commit(types.SET_FILTER_BY, filterBy)
  },
  setFilterOptions({ commit }, data) {
    commit(types.SET_FILTER_OPTIONS, data)
  },
  initCalibrate({ commit }, data) {
    commit(types.INIT_CALIBRATE, data)
  },
  initCalibrateEvent({ commit }, data) {
    commit(types.INIT_CALIBRATEEVENT, data)
  },
  updateCalibrate({ commit }, data) {
    commit(types.UPDATE_CALIBRATE, data)
  },
  setCalibrateStatus({ commit }, data) {
    commit(types.SET_CALIBRATESTATUS, data)
  },
  updateCalibrateEvent({ commit }, data) {
    commit(types.UPDATE_CALIBRATEEVENT, data)
  },
  updateCalibrateEventState({ commit }, data) {
    commit(types.UPDATE_CALIBRATEEVENT_STATE, data)
  },
  setCalibrateEventDialog({ commit }, is) {
    commit(types.SET_CALIBRATEEVENT_DIALOG, is)
  },
  setCalibrateCounts({ commit }, data) {
    console.log('Got Counts', data)
    if (data !== undefined && data !== null) {
      if (data.message !== undefined && data.message !== null) {
        commit(types.SET_CALIBRATECOUNTS, data.message)
      }
    }
  },
  setCalibrateChatCounts({ commit }, data) {
    commit(types.SET_CALIBRATE_CHATCOUNTS, data)
  },
  setServiceApproval({ commit }, data) {
    commit(types.SET_SERVICE_APPROVAL, data)
  },
  async getCalibrateServiceRates({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getCalibrateServiceRates', () =>
      http.get(`calibrate/calibrateServiceRates?firm=${firm}`)
    )
    commit(types.SET_CALIBRATE_SERVICE_RATES, r.data)
    return r.data
  },
  async saveCalibrateServiceRates({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveCalibrateServiceRates', () =>
      http.post('calibrate/saveCalibrateServiceRates', data)
    )
    return r.data
  },
  async getCalibrates({ commit, dispatch }, searchOptions) {
    const r = await startLoading(dispatch, 'getCalibrates', () =>
      http.get('calibrate/calibrates', {
        params: searchOptions
      })
    )
    r.data.filter = searchOptions.filter
    commit(types.SET_CALIBRATES, r.data)
    return r.data
  },
  async getCalibrate({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getCalibrate', () =>
      http.get(`calibrate/calibrate?id=${id}`)
    )
    commit(types.SET_CALIBRATE, r.data)
    return r.data
  },
  async saveCalibrate({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveCalibrate', () =>
      http.post('calibrate/saveCalibrate', data)
    )
    return r.data
  },
  async getCalibrateEvents({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getCalibrateEvents', () =>
      http.get(`calibrate/calibrateEvents?calibrate=${id}`)
    )
    commit(types.SET_CALIBRATEEVENTS, r.data)
    return r.data
  },
  async getCalibrateEvent({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getCalibrateEvent', () =>
      http.get(`calibrate/calibrateEvent?id=${data.id}&username=${data.username}`)
    )
    commit(types.SET_CALIBRATEEVENT, r.data)
    return r.data
  },
  async getOwnerCalibrates({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getOwnerCalibrates', () =>
      http.get(`calibrate/ownerCalibrates?contact=${id}`)
    )
    commit(types.SET_CALIBRATEEVENTS, r.data)
    return r.data
  },
  async saveCalibrateEvent({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveCalibrateEvent', () =>
      http.post('calibrate/saveCalibrateEvent', data)
    )
    commit(types.SET_CALIBRATEEVENTID, r.data)
    return r.data
  },
  async deleteCalibrateEvent({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteCalibrateEvent', () =>
      http.post('calibrate/deleteCalibrateEvent', data)
    )
    return r.data
  },
  async updateStatusCalibrate({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateStatusCalibrate', () =>
      http.post('calibrate/updateStatusCalibrate', data)
    )
    commit(types.SET_CALIBRATESTATUS, data)
    return r.data
  },
  async sendReport({ commit, dispatch }, report) {
    const r = await startLoading(dispatch, 'sendReport', () =>
      http.get(
        `report/send${report.report}?calibrateEvent=${report.calibrateEvent}&NoDiscount=${report.noDiscount}`
      )
    )
    return r.data
  },
  async getRepairLines({ commit, dispatch }, calibrate) {
    const r = await startLoading(dispatch, 'getRepairLines', () =>
      http.get(`calibrate/calibrateRepairLines?calibrate=${calibrate}`)
    )
    commit(types.SET_REPAIRLINES, r.data)
    return r.data
  },
  async getCalibrateEventFileInfo({ commit, dispatch }, calibrateEvent) {
    const r = await startLoading(dispatch, 'getCalibrateEventFileInfo', () =>
      http.get(`calibrate/calibrateEventFileInfo?calibrateEvent=${calibrateEvent}`)
    )
    commit(types.SET_CALIBRATEEVENT_FILEINFO, r.data)
    return r.data
  },
  async calibrateCounts({ commit }, data) {
    const r = await http.get(`calibrate/calibrateCounts?firm=${data.firm}&type=${data.type}`)
    commit(types.SET_CALIBRATECOUNTS, r.data)
    return r.data
  },
  async updateStatusCalibrateEvent({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateStatusCalibrateEvent', () =>
      http.post('calibrate/updateStatusCalibrateEvent', data)
    )
    return r.data
  },
  async updateRequestStatus({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateRequestStatus', () =>
      http.post('calibrate/updateRequestStatus', data)
    )
    return r.data
  },
  async updateCalibrateEventActivity({ commit, dispatch }, activity) {
    const r = await startLoading(dispatch, 'updateCalibrateEventActivity', () =>
      http.post('calibrate/updateCalibrateEventActivity', activity)
    )
    commit(types.SET_CALIBRATEEVENT_ACTIVITY, activity)
    return r.data
  },
  async saveCalibrateEventSchedule({ commit, dispatch }, scheduled) {
    const r = await startLoading(dispatch, 'saveCalibrateEventSchedule', () =>
      http.post('calibrate/saveCalibrateEventSchedule', scheduled)
    )
    return r.data
  },
  async sendForAuthorization({ commit }, calibrateEvent) {
    const r = await http.get(`admin/sendForAuthorization?calibrateEvent=${calibrateEvent}`)
    return r.data
  },
  async getCalibrateServicesForAuthorization({ commit, dispatch }, calibrateEvent) {
    const r = await startLoading(dispatch, 'getCalibrateServicesForAuthorization', () =>
      http.get(`calibrate/getCalibrateServicesForAuthorization?calibrateEvent=${calibrateEvent}`)
    )
    commit(types.SET_REQUEST_SERVICES, r.data)
    return r.data
  },
  async updateServiceAuthorization({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateServiceAuthorization', () =>
      http.post('calibrate/updateServiceAuthorization', data)
    )
    return r.data
  },
  async sendForAuthorizationService({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'sendForAuthorizationService', () =>
      http.get(`admin/sendForAuthorizationService?CalibrateEvent=${id}`)
    )
    return r.data
  },
  async updatePaymentCalibrateEvent({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updatePaymentCalibrateEvent', () =>
      http.post('calibrate/updatePaymentCalibrateEvent', data)
    )
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/calibrates/actions.js